import { render, staticRenderFns } from "./OrderStatusBar.vue?vue&type=template&id=303ff5ea&"
import script from "./OrderStatusBar.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports